import { App } from 'vue';
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { RedirectRoute } from '@/router/base';
import { PageEnum } from '@/enums/pageEnum';
import { createRouterGuards } from './router-guards';

const modules = import.meta.glob('./modules/**/*.ts', { eager: true });

const routeModuleList: RouteRecordRaw[] = [];

Object.keys(modules).forEach((key) => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});

function sortRoute(a, b) {
  return (a.meta?.sort || 0) - (b.meta?.sort || 0);
}

routeModuleList.sort(sortRoute);

export const RootRoute: RouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  // Production uses Azure AD (MSAL) SSO login; QA and local dev use the
  // username/password page for easier testing without real Azure accounts.
  component:
    import.meta.env.MODE === 'production'
      ? () => import('@/views/login/index.vue') // AD / MSAL SSO (prod)
      : () => import('@/views/login/localLogin.vue'), // username/password (qa + dev)
  meta: {
    title: 'Login',
  },
};

// HEPS Deployment phone app sign-in handoff (static; no session, no layout, no menu).
export const AppAuthRoute: RouteRecordRaw = {
  path: '/app-auth',
  name: 'AppAuth',
  component: () => import('@/views/app-auth/index.vue'),
  meta: {
    title: 'HEPS Deployment sign-in',
    ignoreAuth: true,
  },
};

//需要验证权限
export const asyncRoutes = [...routeModuleList];

//普通路由 无需验证权限
export const constantRouter: any[] = [LoginRoute, AppAuthRoute, RootRoute, RedirectRoute];

export const router = createRouter({
  history: createWebHashHistory(''),
  routes: constantRouter,
  strict: true,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
  },
});

export function setupRouter(app: App) {
  app.use(router);
  // 创建路由守卫
  createRouterGuards(router);
}

export default router;
